import { graphql } from "relay-runtime"
import { useBetterDocMutation } from "@/modules/admin/better-doc/hooks/useBetterDocMutation"
import { useSelectBetterDocMedicMutation as useSelectBetterDocMedicMutationType } from "@/modules/admin/better-doc/services/__generated__/useSelectBetterDocMedicMutation.graphql"

const mutation = graphql`
  mutation useSelectBetterDocMedicMutation($input: De_selectBetterDocMedicInput!) {
    de_selectBetterDocMedic(input: $input) {
      actionResult: de_BetterDocSessionActionResult {
        sessionId
        isSuccessful
        httpStatusCode
        betterDocState
        caseId
        errorReason
        exchangeId
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

export const useSelectBetterDocMedicMutation = () => {
  return useBetterDocMutation<useSelectBetterDocMedicMutationType>(mutation)
}
